import { useMemo } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { isMobile, isPhone } from '#src/app/shared/utils/userAgent';

export function useIsMobile(): boolean {
	const utilityContext = useUtilityContext();

	return useMemo(() => {
		try {
			return isMobile(utilityContext);
		} catch {
			return false;
		}
	}, [utilityContext]);
}

/**
 * Phones only — unlike `useIsMobile()`, which also matches tablets. See `isPhone` for when to
 * prefer it.
 */
export function useIsPhone(): boolean {
	const utilityContext = useUtilityContext();

	return useMemo(() => {
		try {
			return isPhone(utilityContext);
		} catch {
			return false;
		}
	}, [utilityContext]);
}
